// extracted by mini-css-extract-plugin
module.exports = {"micro_soft_page":"index_micro_soft_page__1dyME","success_msg":"index_success_msg__rkP0t"};